import { createRecaptchaClient } from '@caterinx/api-client/recaptcha';

/**
 * Der Bot-Schutz des Portals.
 *
 * **Hier steht bewusst keine Logik** — dieselbe Begründung wie in `api.ts`: Das Laden des
 * Skripts, die Einwilligungsprüfung und das Erzeugen des Tokens leben in
 * `@caterinx/api-client/recaptcha`, weil die Marketing-Seite dasselbe für den Chat-Start
 * braucht. Was hier bleibt, ist der Site-Key, und der bleibt hier, weil Vite
 * `import.meta.env.VITE_*` zur Bauzeit **statisch** ersetzt: Ein geteiltes Modul könnte die
 * Variable gar nicht lesen.
 *
 * Ist kein Schlüssel gesetzt (lokale Entwicklung), liefert der Client stumm `null` — der
 * Server entscheidet dann, und auf staging läuft die Registrierung ohne Captcha durch.
 */
export const recaptcha = createRecaptchaClient(import.meta.env.VITE_RECAPTCHA_SITE_KEY ?? '');
